import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { TeamPagePrefetchedDataProps } from 'src/app/pages/about/team/pageContext';
import { prefetchPageContext, TeamPageContextProvider } from 'src/app/pages/about/team/pageContext';

import { Layout } from '../layout';

import { TeamErrorHandler } from './ErrorHandler';

export const Team = withPrefetchedData(
	function Team({ prefetchedData }: TeamPagePrefetchedDataProps) {
		return (
			<TeamPageContextProvider
				prefetchedData={prefetchedData}
				errorHandler={TeamErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</TeamPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
	},
);
